// Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React from 'react'
import { Box, Typography, Link } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import XIcon from '@mui/icons-material/X'
import TelegramIcon from '@mui/icons-material/Telegram'

const Footer: React.FC = () => {
  const theme = useTheme()

  const isLytSierraApp = theme.palette.background.paper === '#00000e'

  return (
    <Box
      data-testid="Footer"
      component="footer"
      sx={{
        pt: isLytSierraApp ? 5 : 1.5,
        pb: isLytSierraApp ? 5 : 1.5,
        px: isLytSierraApp ? 0 : 2,
        backgroundColor: theme.palette.background.paper,
        borderTop: isLytSierraApp ? `1px solid rgba(255, 255, 255, 0.1)` : `1px solid ${theme.palette.divider}`,
        width: '100%',
        marginTop: isLytSierraApp ? '40px' : '20px',
        marginBottom: isLytSierraApp ? '20px' : '0px',
      }}
    >
      <Box
        data-testid="FooterInner"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          ...(isLytSierraApp
            ? {
                px: '24px',
                width: '100%',
              }
            : {
                maxWidth: '1200px',
                margin: '0 auto',
              }),
        }}
      >
        {isLytSierraApp ? (
          <>
            <Box sx={{ flex: 1 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <Link
                href="https://docs.sierra.money/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'white',
                  textDecoration: 'none',
                  fontSize: '16px',
                  fontWeight: 500,
                  '&:hover': {
                    color: '#E769A6',
                  },
                }}
              >
                DOCS
              </Link>
              <Link
                href="https://x.com/SierraIsMoney"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  '&:hover': {
                    color: '#E769A6',
                  },
                }}
              >
                <XIcon sx={{ fontSize: 28 }} />
              </Link>
              <Link
                href="https://t.me/SierraIsMoney"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  '&:hover': {
                    color: '#E769A6',
                  },
                }}
              >
                <TelegramIcon sx={{ fontSize: 28 }} />
              </Link>
            </Box>
          </>
        ) : (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="caption" color="bodyMuted" sx={{ fontSize: '0.75rem' }}>
                Copyright Open Trade Technology Ltd. 2023-2025
              </Typography>
              <Typography variant="caption" color="bodyMuted" sx={{ fontSize: '0.75rem' }}>
                All rights reserved.
              </Typography>
            </Box>

            <Link
              href="https://docs.opentrade.io/stablecoin-yield/product-overview/legal/platform-terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: theme.palette.primary.main,
                textDecoration: 'none',
                fontSize: '0.75rem',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              Platform Terms of Service
            </Link>
          </>
        )}
      </Box>
    </Box>
  )
}

export default Footer
